import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-annexes',
  templateUrl: './annexes.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./annexes.component.less']
})
export class AnnexesComponent implements OnInit {
  @Input() class?: string;
  @Input() annexes!: string[];
  sanitizedAnnexes!: SafeHtml[];

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    //this.sanitizedAnnexes = this.annexes.map(annexe => this.sanitizer.bypassSecurityTrustHtml(annexe));
    this.sanitizedAnnexes = this.annexes.map(annexe => {
      if (annexe.includes('data-document-id')) {
        return this.sanitizer.bypassSecurityTrustHtml(annexe);
      }
      return annexe;
    });
  }

}
